export class AvisConcerne {

  public standard: boolean;

  public mise_En_Concurrence: boolean;

  constructor() {
    this.standard = true;
    this.mise_En_Concurrence = true;

  }
}
